import store from "@/store";
export default {
  clickOutSide: {
    bind(el, binding) {
      function documentHandler(e) {
        if (el.contains(e.target)) {
          return false;
        }
        if (binding.expression) {
          binding.value(e);
        }
      }
      el._clickOutSide_ = documentHandler;
      document.addEventListener("click", documentHandler);
    },
    unbind(el) {
      document.removeEventListener("click", el._clickOutSide_);
      delete el._clickOutSide_;
    },
  },
  selectLoadMore: {
    bind(el, binding) {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      SELECTWRAP_DOM.addEventListener("scroll", function () {
        const CONDITION =
          this.scrollHeight - this.scrollTop === this.clientHeight;
        if (CONDITION) {
          binding.value();
        }
      });
    },
  },
  permission: {
    async bind(el, binding, vnode) {
      const that = vnode.context;

      const hasPermission = await store.dispatch(
        "permission/hasPermission",
        binding.arg
      );

      if (!binding.value && !hasPermission) {
        el.remove();
      }

      if (binding.value && binding.value.clickFn) {
        el.__vuePermissionClick__ = documentHandler;
        el.addEventListener("click", documentHandler);
      }

      function documentHandler() {
        if (hasPermission) {
          const args = binding.value.args || [];
          binding.value.clickFn(...args);
        } else {
          that.$message({
            message: "您的权限无法使用该功能，可联系超级管理员修改权限",
            type: "warning",
          });
        }
      }
    },
    unbind(el) {
      if (el.__vuePermissionClick__) {
        document.removeEventListener("click", el.__vuePermissionClick__);
        delete el.__vuePermissionClick__;
      }
    },
  },
  ellipsis: {
    bind(el, binding) {
      el.style.overflow = "hidden";
      el.style.textOverflow = "ellipsis";
      const n = parseInt(binding.arg);
      if (!binding.arg || n <= 1) {
        el.style.whiteSpace = "nowrap";
      }
      if (n > 1) {
        el.style.display = "-webkit-box";
        el.style["-webkit-line-clamp"] = n;
        el.style["-webkit-box-orient"] = "vertical";
      }
    },
  },
};
